import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { OkrLabel } from '~src/store/okrs/interfaces';
import { ButtonColorTypes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';

import { ButtonWrapper, DeleteConfirmation, ModalSubtitle, ModalTitle } from './deletionConfirmationModal.sc';

interface Props {
  delete: (id: string) => void;
  hide: () => void;
  label: OkrLabel;
  loading: boolean;
}

const DeletionConfirmationModal: FC<Props> = props => {
  const deleteCall = () => {
    props.delete(props.label.id);
  };

  const [t] = useTranslation();

  return (
    <DeleteConfirmation>
      <ModalTitle data-translation="x.okr.labels.delete.title">{t('x.okr.labels.delete.title')}</ModalTitle>
      <ModalSubtitle data-translation="x.okr.labels.delete.subtitle">
        {t('x.okr.labels.delete.subtitle')}
      </ModalSubtitle>
      <ButtonWrapper>
        <SecondaryButton type="button" onClick={props.hide} data-translation="x.okr.labels.delete.cancel">
          {t('x.okr.labels.delete.cancel')}
        </SecondaryButton>
        <PrimaryButtonLoading
          type="button"
          onClick={deleteCall}
          $buttonColor={ButtonColorTypes.Reddish}
          data-translation="x.okr.objective.form.delete"
          isLoading={props.loading}
        >
          {t('x.okr.objective.form.delete')}
        </PrimaryButtonLoading>
      </ButtonWrapper>
    </DeleteConfirmation>
  );
};

export default DeletionConfirmationModal;
